import React, { useEffect, useState } from 'react'
import { Avatar, Box, Circle, Flex, Spacer, Text } from '@chakra-ui/react'
import PropTypes from 'prop-types'
import CommentOptions from '../CommentOptions'
import { formatRelative } from 'date-fns'
import { observer } from 'mobx-react'
import rootStore from '../../../../store/RootStore'

const CommentListItemHeader = observer(
  ({ user, dateUpdated, index, commentId, hideMoreMenu = false, ...rest }) => {
    const {
      authStore: { user: authUser },
    } = rootStore

    const [date, setDate] = useState('')
    useEffect(() => {
      try {
        setDate(formatRelative(new Date(dateUpdated), new Date()))
      } catch (e) {
        setDate(dateUpdated)
      }
    }, [dateUpdated])
    return (
      <Flex
        p="12px 16px"
        textStyle="comments"
        position="relative"
        {...rest}
      >
        <Avatar
          objectFit="cover"
          w="40px"
          h="40px"
          name={user.name}
          src={user.avatar}
          mr="12px"
        />
        <Box>
          <Text>
            {user.name}
            <Text
              as="span"
              fontSize={14}
              color={'brand.textGray'}
            >
              {authUser.id === user.id && '- You'}
            </Text>
          </Text>
          <Text
            color={'brand.textGray'}
            noOfLines={1}
          >
            {date}
          </Text>
        </Box>
        <Spacer />
        {user.id === authUser.id && !hideMoreMenu && (
          <CommentOptions commentId={commentId} />
        )}
        {index !== undefined && (
          <Circle
            borderRadius="100%"
            position="absolute"
            width="20px"
            height="20px"
            left="40px"
            bottom="8px"
            backgroundColor="orange"
            border="2px solid"
            borderColor="white"
            fontSize="11px"
            color="white"
            alignItems="center"
            justifyContent="center"
            fontWeight="bold"
          >
            {index + 1}
          </Circle>
        )}
      </Flex>
    )
  },
)

CommentListItemHeader.propTypes = {
  user: PropTypes.any.isRequired,
  dateUpdated: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  index: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  hideMoreMenu: PropTypes.bool,
  commentId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

export default React.memo(CommentListItemHeader)
